export const COLUMN_DATE_FORMAT = "DD MMM YYYY";
export const PII_FIELDS = ["name", "email"] as const;
export const FIELD_REBATE_ACCOUNT_ID = "rebateAccountID";
export const chartPieColors = new Map<string, string>([
  ["standard", "rgba(153, 193, 253, 1)"],
  ["razor", "rgba(248, 206, 152, 1)"],
  ["mam", "rgba(227, 192, 240, 1)"],
  ["mam master", "rgba(227, 192, 240, 1)"],
  ["mam slave", "rgba(227, 192, 240, 1)"],
  ["swap-free", "rgba(180, 245, 156, 1)"],
  ["swap free", "rgba(180, 245, 156, 1)"],
  ["islamic", "rgba(180, 245, 156, 1)"],
  ["spread betting", "rgba(242, 175, 169, 1)"],
  ["limited risk", "rgba(3, 20, 46, 0.3)"],
  ["ctrader", "rgba(153, 193, 253, 1)"],
  ["mt4", "rgba(248, 206, 152, 1)"],
  ["mt5", "rgba(227, 192, 240, 1)"],
  ["pepperstone", "rgba(180, 245, 156, 1)"],
  ["tradingview", "rgba(242, 175, 169, 1)"],
]);
